import { create } from 'zustand';
import {
  Notification,
} from '@scrambl/shared';
import { createSelectors } from '../factories/createSelectors';

// UI State only - for real-time updates
interface NotificationState {
  handleNotificationCreated: (notification: Notification) => void;
  handleNotificationUpdated: (notificationId: string, updates: Partial<Notification>) => void;
  handleNotificationDeleted: (notificationId: string) => void;
  handleUnreadCountUpdated: (count: number) => void;
  reset: () => void;
}

const createDefaultHandlers = (): Omit<NotificationState, 'reset'> => ({
  handleNotificationCreated: (notification: Notification) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('scrambl:notification-created', {
          detail: notification,
        })
      );
    }
  },
  handleNotificationUpdated: () => {
    // Query invalidation handled in notification hooks
  },
  handleNotificationDeleted: () => {
    // Query invalidation handled in notification hooks
  },
  handleUnreadCountUpdated: () => {
    // Query invalidation handled in notification hooks
  },
});

const notificationStore = create<NotificationState>()((set) => ({
  ...createDefaultHandlers(),
  reset: () => set(createDefaultHandlers()),
}));

export const useNotificationStore = createSelectors(notificationStore);
